export const PBS_BACKGROUND_COLOR = '#FFF';
